import html from "./CompletionStep.html"

var module = angular.module("ResearchKitApplicationModule");

module.directive("completionStep",
	["ceUrl", function (ceUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			},
			link: function (scope, iElement, iAttrs, controller) {
				scope.imageUrl = function () {
					return ceUrl.make('content/researchkit/images/completion.png');
				}
			}
		};
	}]
);